import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-b2b-format',
  templateUrl: './b2b-format.component.html',
  styleUrls: ['./b2b-format.component.scss']
})
export class B2bFormatComponent implements OnInit {

  @Input() data: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
